<template>
  <b-modal
    id="popup"
    dialog-class="popup-wrap"
    centered
    hide-backdrop
    content-class="shadow"
    hide-header
  >
    <b-carousel
      id="carousel-1"
      :interval="5000"
      indicators
      class="carousel-style2"
    >
      <popup-item v-for="(popup,index) in popupList" :key="index" :popup="popup" :width="windowWidth" />
    </b-carousel>
    <template #modal-footer="{ hide }">
      <b-button size="lg" @click="hideForOneDay()">
        오늘 그만보기
      </b-button>
      <b-button size="lg" @click="hide()">
        닫기
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import PopupItem from './PopupItem.vue';

export default {
  name: 'Popup',
  props: {
    popupList: {
      type: Array,
      default: () => [],
    },
    windowWidth: {
      type: Number,
      required: true,
    }
  },
  components: {
    PopupItem,
  },
  methods: {
    hideForOneDay() {
      this.$cookies.set('hidePopup', true);
      this.$bvModal.hide('popup');
    },
  },
};
</script>
